import { NotFound } from "@dgs/core";
import { FC } from "react";
import { Route, Routes } from "react-router";
import { CostCategoryList } from "./CostCategoryList";

export const CostCategoriesPage: FC = () => {
	return (
		<Routes>
			<Route index element={<CostCategoryList />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
};
